export const ROOT_MENU_ID = "20210823300000000763"

export function isSurveyTrackedMenu(item) {
  return Boolean(item?.parentMenuId) && item.parentMenuId !== ROOT_MENU_ID
}
